import {observer} from "mobx-react";
import rootStores from "@/Stores/RootStores";
import {mapCatalogSortOptions} from "@/features/catalog-sort";
import {CatalogSortDto, FilterOption} from "../model/types";
import {Svg} from "@/shared/ui/Svg";
import {FilterDropdown} from "@/shared/ui/FilterDropdown";
import {CatalogSortOptionsFilter} from "@/features/catalog-sort";
import {useState} from "react";
import {useCatalogFilterDrawer} from "@/widgets/catalog-filter-drawer";
import styles from "./CatalogSort.module.scss";

type Props = {
    dataSort: CatalogSortDto[];
    isDesktop: boolean;
};

export const CatalogSort = observer((
    {
        dataSort,
        isDesktop,
    }: Props
) => {
    const [opened, setOpened] = useState(false);
    const openModal = useCatalogFilterDrawer(s => s.actions.openModal);
    const {catalogStore} = rootStores;

    const options = mapCatalogSortOptions({
        options: dataSort,
    });

    const handleChange = (option: FilterOption) => {
        catalogStore.applySorting(option);

        setOpened(false);
    };

    const handleMobileOpen = () => {
        openModal(`sorting`);
    };

    return (
        <FilterDropdown
            opened={opened}
            onOpenChange={setOpened}
            title={catalogStore?.selectedSortingName}
            titleClassName={styles.sortTitle}
            iconLeft={<Svg id={`sortFiltersIcon`} className={styles.icon} />}
            isDesktop={isDesktop}
            onMobileOpen={handleMobileOpen}
            filterType={`sort`}
        >
            <CatalogSortOptionsFilter
                options={options}
                selectedValue={catalogStore.selectedSortingValue}
                onChange={handleChange}
            />
        </FilterDropdown>
    );
});
